import React from "react"
import { nanoid } from "nanoid"

import { HiInformationCircle } from "react-icons/hi"
// import { FcCheckmark } from "react-icons/fc"
// import { FaTimes } from "react-icons/fa"
import Caloric from "./Caloric"
import Tooltip from "../Tooltip"

function Nutrition({ nutrition }) {
    return (
        <article className="nutrition" key={nanoid()}>
            <Caloric caloric={nutrition?.caloricBreakdown} weight={nutrition?.weightPerServing.amount} />

            <section className="index">
                { nutrition?.properties.map( item => {
                    return <>
                        <div key={nanoid()}>
                            <span>{item.name}</span>
                            <Tooltip 
                                content={item.name === "Glycemic Index" 
                                    ? "The glycemic index (GI) assigns a numeric score to a food based on how drastically it makes your blood sugar rise. Foods are ranked on a scale of 0 to 100, with pure glucose (sugar) given a value of 100. The lower a food's glycemic index, the slower blood sugar rises after eating that food. In general, the more processed a food is, the higher its GI, and the more fiber or fat in a food, the lower it's GI"
                                    : "Whereas the Glycemic Index is a good way of making food choices, Glycemic load helps to work out how different sized portions of different foods compare with each other in terms of their blood glucose raising effect."}
                                direction="top"
                                key={nanoid()}
                            >
                                <HiInformationCircle/>
                            </Tooltip>
                        </div>
                        <span>{item.amount}</span>
                    </>
                }) }
            </section>

            <table className="nutritionTable">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Amount</th>
                        <th>Daily Need</th>
                        {/* <th>Sufficient</th> */}
                    </tr>
                </thead>
                { nutrition?.nutrients?.map( item =>  {
                    return <tbody key={nanoid()}>
                        <tr>
                            <td>{item.title}</td>
                            <td>{item.amount} {item.unit}</td>
                            <td>{item.percentOfDailyNeeds} {item.unit}</td>
                            {/* <td>{item.amount < item.percentOfDailyNeeds ? <FcCheckmark/> : <FaTimes/>}</td> */}
                        </tr>
                    </tbody>
                }) }
            </table>
        </article>
    )
}

export default Nutrition
